<template>
    <div class="col-12 account-lookup-view-list">
      <div class="search-padd">
      <form v-on:submit.prevent>
        <div class="col-xs-12 override-padding">
            <div class="crm_admin_heading form_heading_1 text-align-center">&nbsp;</div>
          <div class="crm_admin_heading form_heading_2 text-align-left">Form Name</div>
          <div class="crm_admin_heading form_heading_3 text-align-center"># of Fields</div>
          <div class="crm_admin_heading form_heading_4 text-align-center">Last Updated</div>
        </div>
        <div style="clear: both;"></div>
        <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
            <div v-if="formslists.length > 0" class="view-accountlist">
                <div class="tasklist-row" id="forms_list_more" v-for="(form, index) in formslists" :key="index">
                    <div class="row tasklist-item col-12">
                        <div class="crm_admin_field_lists form_heading_1 text-align-center">
                            <span>
                                <input type="checkbox"
                                v-bind:id="'forms_'+index"
                                v-bind:value="form.id"
                                name="forms"
                                v-model="forms_selected"
                                :ref="'form_checkbox_' + index"
                                @click="setFormAffiliates(form.id, $event)">
                            </span>                              
                        </div>
                        <div class="crm_admin_field_lists form_heading_2 text-align-left">
                            {{ form.name }}
                        </div>
                        <div class="crm_admin_field_lists form_heading_3 text-align-center">
                            {{ form.total_assigned_fields }}
                        </div>
                        <div class="crm_admin_field_lists form_heading_4 text-align-center">
                            {{ form.updatedAt | formatFormUpdatedDate }}
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                No Form Found
            </div>
          <div style="clear: both;"></div>
        </form>
      </div>
    </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import { store } from '../../store/store';
import EventBus from '../../bus';
import moment from 'moment';
Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

Vue.filter('formatFormUpdatedDate', function(value) {
  if (value) {
    return moment(String(value)).format('MM/DD/YYYY')
  }
});

export default {
      props: ['accountId'],
      data() {
        return {
          forms_selected: [],
          formslists: [],
          loading: false,
          form_affiliates: [],
        }
      },
      methods: {
        fetchFormsManager: function() {
            this.loading = true;
            axios('/affiliate/forms-manager',
              {
                method: 'POST',
              },
            )
            .then((resp) => {
                this.loading = false;
                this.formslists = resp.data.data;
                if (resp.data.forms_selected.length > 0) {
                  this.forms_selected = resp.data.forms_selected;
                } else {
                  this.forms_selected = [];
                }
            })
            .catch(error => {

            });
        },
        setFormAffiliates(formId, event) {
          if (event.target.checked) {
            this.form_affiliates.push(formId);  
          } else {
              var index = this.form_affiliates.indexOf(formId);
              if (index !== -1) {
                this.form_affiliates.splice(index, 1);
              }
          }
        },
      },
      created: function () {
        if (store.state.search_parameters) {
          this.forms_selected = store.state.search_parameters.search_form.forms_selected;
        }
        if (store.state.search_enterprise_parameters) {
          this.forms_selected = store.state.search_enterprise_parameters.search_form.forms_selected;
        }
        this.fetchFormsManager();
      },
    }
</script>


<style>
.form_heading_1 {
  width: 10%;
}
.form_heading_2 {
  width: 30%;
}
.form_heading_3 {
  width: 10%;
}
.form_heading_4 {
  width: 50%;
}
.account-lookup-view-list .tasklist-item {
    padding: 3px 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/account_lookup_search_forms_tab.vue